import Swal from "sweetalert2";
import React, { useState, useEffect } from 'react';
import { Field, Form } from 'react-final-form';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import renderSelectField from '@/shared/components/form/Select';
import renderCheckBoxField from '@/shared/components/form/CheckBox';
import renderComponentField from '@/shared/components/form/FormField';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { CollectionCategoryEnum, CollectionCardinalDirectionEnum } from '../../../../../Enums';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const required = value => (value ? undefined : 'Required')

const CollectionsList = (props) => {
    const [collection, setCollection] = useState();
    const [collectionsList, setCollectionsList] = useState();

    const GetCollections = () => {
        AdminInterface.instance.getCollections().then((response) => {
            setCollectionsList(response.data)
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error in getting collections.'
            });
        }).finally(() => {
            props.setListRequiresReload(false);
        });
    }

    useEffect(() => {
        if (collectionsList == undefined) return;

        let parent_id_label = null;
        if (props.selectedCollection.parent_id != null) {
            collectionsList.forEach(function (collection) {
                if (collection.id == props.selectedCollection.parent_id) {
                    parent_id_label = collection.name;
                }
            })

        }
        setCollection({
            id: props.selectedCollection.id,
            name: props.selectedCollection.name,
            parent_id: { label: parent_id_label, value: props.selectedCollection.parent_id },
            is_demonstrable: props.selectedCollection.is_demonstrable,
            is_exportable: props.selectedCollection.is_exportable,
            category: { label: Object.keys(CollectionCategoryEnum).find(category => CollectionCategoryEnum[category] === props.selectedCollection.category), value: props.selectedCollection.category },
            cardinal_direction: { label: Object.keys(CollectionCardinalDirectionEnum).find(direction => CollectionCardinalDirectionEnum[direction] === props.selectedCollection.cardinal_direction), value: props.selectedCollection.cardinal_direction },
            default_bucket_name: props.selectedCollection.default_bucket_name,
        })
    }, [collectionsList]);

    useEffect(() => {
        GetCollections();
    }, [props.selectedCollection]);

    const submitCollectionUpdates = (collection) => {
        let data = {}
        data.id = collection.id;
        data.name = collection.name;
        data.category = collection.category?.value;
        data.parent_id = collection.parent_id?.value;
        data.is_exportable = collection.is_exportable;
        data.is_demonstrable = collection.is_demonstrable;
        data.default_bucket_name = collection.default_bucket_name;
        data.cardinal_direction = collection.cardinal_direction?.value;
        AdminInterface.instance.updateCollection(data).then(() => {
            Swal.fire('Updated!', '', 'success')
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: error.response.data?.detail,
            });
        })
    }

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>Edit Collection</CardTitle>
                </CardTitleWrap>
                {collectionsList && <Form onSubmit={submitCollectionUpdates} initialValues={collection}>
                    {({ handleSubmit, form }) => (
                        <FormContainer horizontal onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormGroupLabel>Name</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="name" component={renderComponentField} placeholder="Name" validate={required} />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Parent</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="parent_id" component={renderSelectField}
                                        options={collectionsList.map(function (collection) {
                                            return { value: collection.id, label: collection.name }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Category</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="category" component={renderSelectField} validate={required}
                                        options={Object.keys(CollectionCategoryEnum).map(function (key) {
                                            return { value: CollectionCategoryEnum[key], label: key }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Default Bucket Name</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="default_bucket_name" component={renderComponentField} placeholder="For example: fm-tms"/>
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Cardinal Direction</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="cardinal_direction" component={renderSelectField}
                                        options={Object.keys(CollectionCardinalDirectionEnum).map(function (key) {
                                            return { value: CollectionCardinalDirectionEnum[key], label: key }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupField>
                                    <Field
                                        name="is_exportable"
                                        type="checkbox"
                                        component={renderCheckBoxField}
                                        label="Exportable"
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupField>
                                    <Field
                                        name="is_demonstrable"
                                        type="checkbox"
                                        component={renderCheckBoxField}
                                        label="Demonstrable"
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormButtonToolbar>
                                <Button variant="primary" type="submit">Submit</Button>
                                <Button variant="secondary" type="button" onClick={() => props.setSelectedCollection(null)}>
                                    Cancel
                                </Button>
                            </FormButtonToolbar>
                        </FormContainer>
                    )}
                </Form>}
            </CardBody>
        </Card>
    );
};

export default CollectionsList;